var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useField, useFormikContext } from "formik";
import React, { useEffect, useRef, useState } from "react";
export var FormItemImageUpload = function (_a) {
    var name = _a.name, label = _a.label, buttonLabel = _a.buttonLabel, buttonRemoveLabel = _a.buttonRemoveLabel, tooltip = _a.tooltip;
    var inputRef = useRef(null);
    var setFieldValue = useFormikContext().setFieldValue;
    var _b = __read(useField(name), 2), field = _b[0], meta = _b[1];
    var touched = meta.touched, error = meta.error;
    var value = field.value;
    var _c = __read(useState(value === null || value === void 0 ? void 0 : value.name), 2), fileName = _c[0], setFileName = _c[1];
    var _d = __read(useState(value === null || value === void 0 ? void 0 : value.file), 2), file = _d[0], setFile = _d[1];
    var _e = __read(useState(value === null || value === void 0 ? void 0 : value.src), 2), src = _e[0], setSrc = _e[1];
    var errorText = touched && error ? error : null;
    var handleFileUpload = function (e) {
        var filesList = e.target.files;
        if (!filesList) {
            return;
        }
        var reader = new FileReader();
        var file = filesList[0];
        if (file) {
            reader.onloadend = function () { return setFileName(file.name); };
            if (file.name !== fileName) {
                // readAsArrayBuffer
                // v pripade, že bude treba urychlit load loga (11k image resolution)
                reader.readAsDataURL(file);
                setSrc(reader);
                setFile(file);
            }
        }
    };
    var removeFile = function () {
        setSrc(null);
        setFile(null);
        setFileName("");
        value.name = "";
        value.file = undefined;
        value.src = undefined;
    };
    useEffect(function () {
        if (file && fileName && src) {
            setFieldValue(name, { file: file, src: src, name: fileName });
        }
    }, [src, fileName, file]);
    return (React.createElement("div", { className: "form-item-image-upload" },
        React.createElement("div", { className: "form-item-image-upload__label-wrapper" },
            React.createElement("div", { className: "form-item-image-upload__preview", style: __assign({}, ((src === null || src === void 0 ? void 0 : src.readyState) > 1 && {
                    backgroundImage: "url(" + src.result + ")",
                })) }),
            React.createElement("label", { className: "form-item-image-upload__label" }, label),
            tooltip ? (React.createElement("div", { className: "form-item-image-upload__tooltip" },
                "i",
                React.createElement("div", { className: "form-item-image-upload__tooltip_window" }, tooltip))) : (React.createElement(React.Fragment, null))),
        React.createElement("input", { ref: inputRef, className: "form-item-image-upload__control", type: "file", accept: "image/*", multiple: true, onChange: handleFileUpload }),
        file == null ? (React.createElement("button", { type: "button", className: "form-item-image-upload__button", onClick: function () { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); } }, buttonLabel)) : (React.createElement("button", { type: "button", className: "form-item-image-upload__button", onClick: function () { return removeFile(); } }, buttonRemoveLabel)),
        errorText && (React.createElement("div", { className: "form-item-image-upload__error scroll_to_error" }, errorText))));
};
